var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "recycle-svgrepo-com 1",
    clipPath: "url(#clip0_11530_88896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.826 13C20.226 13 19.826 12.6 19.826 12C19.826 8.1 16.726 5 12.826 5C10.926 5 9.22598 5.7 7.82598 7C7.52598 7.4 6.82598 7.4 6.42598 7C6.02598 6.6 6.02598 6 6.42598 5.6C8.12598 3.9 10.426 3 12.826 3C17.826 3 21.826 7 21.826 12C21.826 12.6 21.426 13 20.826 13Z",
    fill: "#5EEECD"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.8262 21C7.82617 21 3.82617 17 3.82617 12C3.82617 11.4 4.22617 11 4.82617 11C5.42617 11 5.82617 11.4 5.82617 12C5.82617 15.9 8.92617 19 12.8262 19C14.7262 19 16.4262 18.3 17.8262 17C18.2262 16.6 18.8262 16.6 19.2262 17C19.6262 17.4 19.6262 18 19.2262 18.4C17.5262 20.1 15.2262 21 12.8262 21Z",
    fill: "#5EEECD"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.8256 12.9979C20.6256 12.9979 20.4256 12.8979 20.2256 12.7979L16.8256 10.2979C16.4256 9.99787 16.3256 9.29787 16.6256 8.89787C16.9256 8.49787 17.6256 8.39787 18.0256 8.69787L21.4256 11.1979C21.8256 11.4979 21.9256 12.1979 21.6256 12.5979C21.4256 12.8979 21.1256 12.9979 20.8256 12.9979Z",
    fill: "#5EEECD"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.826 12.9994C20.626 12.9994 20.426 12.8994 20.226 12.7994C19.826 12.4994 19.726 11.7994 20.026 11.3994L22.526 7.99943C22.826 7.59943 23.526 7.49943 23.926 7.79943C24.326 8.09943 24.426 8.79943 24.126 9.19943L21.626 12.5994C21.426 12.8994 21.126 12.9994 20.826 12.9994Z",
    fill: "#5EEECD"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.226 15.4979C8.026 15.4979 7.826 15.3979 7.626 15.2979L4.226 12.7979C3.826 12.4979 3.726 11.7979 4.026 11.3979C4.326 10.9979 4.926 10.8979 5.426 11.1979L8.826 13.6979C9.226 13.9979 9.326 14.6979 9.026 15.0979C8.826 15.3979 8.526 15.4979 8.226 15.4979Z",
    fill: "#5EEECD"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M2.326 16.3979C2.126 16.3979 1.926 16.2979 1.726 16.1979C1.326 15.8979 1.226 15.1979 1.526 14.7979L4.026 11.3979C4.326 10.9979 4.926 10.8979 5.426 11.1979C5.826 11.4979 5.926 12.1979 5.626 12.5979L3.126 15.9979C2.926 16.2979 2.626 16.3979 2.326 16.3979Z",
    fill: "#5EEECD"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11530_88896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.826172)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshDark);
export default __webpack_public_path__ + "static/media/refresh_dark.1bbb871131622d507c04ca46c4262633.svg";
export { ForwardRef as ReactComponent };